const namespace = {
  header: {
    title: "Get to know the neighborhood",
    description:
      "Explore schools, prices, community vibe, and more before you decide to move.",
  },
  cards: {
    neighborhoodIntel: "Neighborhood Lifestyle Report",
    neighborhoodContext: "Neighborhood Context",
    locationInsights: "Location Insights",
    climateRisk: "Climate Risk",
    communityPortrait: "Community Portrait",
    localMarketOverview: "Local Market Overview",
    marketTrendsReport: "Market Trends Report",
    neighborhoodMarketTrends: "Neighborhood Market Trends",
    realTimeData: "Real-Time Data",
    fiveYearHistoricalView: "5-Year Historical View",
    easyToReadFormat: "Easy-to-Read Format",
    actionableInsights: "Actionable Insights",
  },
  downloadCard: {
    title: "Download your neighborhood report",
    description:
      "Instant insights on local lifestyle, demographics, and market trends.",
    cta: "Get your IO Report",
    select: {
      default: "Select report type",
      niReport: "Neighborhood Lifestyle Report",
      marketReport: "Neighborhood Market Report",
      both: "Both",
    },
  },
  contactInfo: {
    back: "Back",
    title: "Just one step away from your reports",
    description:
      "Tell us a bit about yourself and we’ll generate your report(s) instantly. Get local insights and market data in seconds, clear, reliable, and ready when you are.",
  },
} as const;

export default namespace;
